(function () {
  if (customElements.get('alessa-accordion')) return;

  class AlessaAccordion extends HTMLElement {
    constructor() {
      super();
      this.querySelectorAll('.alessa-faq-btn').forEach(function (button) {
        button.addEventListener('click', function () {
          var answer = button.nextElementSibling;
          var isOpen = button.classList.contains('active');
          button.classList.toggle('active');
          answer.classList.toggle('active');
          button.setAttribute('aria-expanded', String(!isOpen));
        });
      });
    }
  }

  customElements.define('alessa-accordion', AlessaAccordion);
})();
